import React, { useEffect, useState } from "react";
import { Button } from "@aph/ui-lib-humanx";
import SectionHeader from "@/components/SectionHeader";
import ShoppingWidget1 from "@/components/ShoppingWidget1";
import TabsComponent from "@/components/ShoppingComponent/Components/TabsComponent";
import { getShoppingProducts } from "@/components/ShoppingComponent/api";
import { useAppSelector } from "@/redux/hooks";
import homeDataSelector from "@/components/PageHome/redux/selectors/homeData";
import pharmaAddressDetailsSelector from "@/redux/slice/location/selectors/pharmaAddressDetails";
import ShoppingWidget2 from "@/components/ShoppingWidget2";
import { CartItem } from "@/redux/slice/cart/types/CartItem";
import ButtonLink from "@/components/ButtonLink";
import styles from "./ShoppingComponent.module.scss";

const ShoppingComponent = (props) => {
  const { userAgent, productInfo, data, desktopItems, isHomePage } = props;
  const homeData = useAppSelector(homeDataSelector);
  const pharmaAddressDetails = useAppSelector(pharmaAddressDetailsSelector);

  //@ts-ignore
  const ageInNumber = homeData?.segmentInfo?.segmentDetail?.ageInNumber;
  //@ts-ignore
  const currentTrimester = homeData?.segmentInfo?.segmentDetail?.currentTrimester;
  const { Title, MaternityCare, MotherhoodStage } = data;
  let categories = [];
  let viewAllProductUrl = "";

  if (isHomePage) {
    if (currentTrimester) {
      const filteredMaternityCare = MaternityCare.filter((data) => data.Trimester === currentTrimester)?.[0];
      categories = filteredMaternityCare?.CategoryList;
      viewAllProductUrl = filteredMaternityCare?.ViewAllProductsUrl;
    } else if (ageInNumber) {
      const filteredMaternityCare = MaternityCare.filter(
        (data) => data.MonthStart >= ageInNumber && data.MonthEnd <= ageInNumber
      )?.[0];
      categories = filteredMaternityCare?.CategoryList;
      viewAllProductUrl = filteredMaternityCare?.ViewAllProductsUrl;
    } else {
      categories = MotherhoodStage?.[0]?.CategoryList;
      viewAllProductUrl = MotherhoodStage?.[0]?.ViewAllProductsUrl;
    }
  } else {
    categories = MaternityCare?.[0]?.CategoryList || MotherhoodStage?.[0]?.CategoryList;
    viewAllProductUrl = MaternityCare?.[0]?.ViewAllProductsUrl || MotherhoodStage?.[0]?.ViewAllProductsUrl;
  }

  const [activeCategory, setActiveCategory] = useState<string>(categories?.[0]?.CategoryId);
  const [products, setProducts] = useState<CartItem[]>(productInfo?.products);

  const fetchProducts = async (categoryId = "") => {
    try {
      const productInfo = await getShoppingProducts({
        currentTrimester,
        ageInNumber,
        CategoryId: categoryId || activeCategory,
        shoppingWidget: {
          MaternityCare,
          MotherhoodStage,
        },
      });

      if (productInfo?.products?.length) {
        setProducts(productInfo?.products);
      } else {
        setProducts([]);
      }
    } catch (err) {
      console.error(err);
      setProducts([]);
    }
  };

  useEffect(() => {
    if (pharmaAddressDetails?.pincode) {
      fetchProducts();
    }
  }, [pharmaAddressDetails?.pincode]);

  const handleTabChange: (CategoryId: string) => void = async (CategoryId) => {
    await fetchProducts(CategoryId);
    setActiveCategory(CategoryId);
  };

  return (
    <>
      <section className={`${styles.root} spacingBetweenSections`}>
        <div className={`container`}>
          <SectionHeader title={Title} userAgent={userAgent} isReadMoreBtn={false} />

          {categories?.length > 1 && (
            <TabsComponent
              tabItems={categories}
              activeItem={activeCategory}
              onTabChange={(slug: any) => handleTabChange(slug)}
              isTabAlignLeft
            />
          )}

          {categories?.length === 1 ? (
            <ShoppingWidget2 userAgent={userAgent} products={products} desktopItems={desktopItems} />
          ) : (
            <ShoppingWidget1 userAgent={userAgent} products={products} desktopItems={desktopItems} />
          )}
          {viewAllProductUrl && (
            <ButtonLink color="tertiarybaby" href={viewAllProductUrl} className={styles.btn}>
              Load more products
            </ButtonLink>
          )}
        </div>
      </section>
    </>
  );
};

export default ShoppingComponent;
